import { CompanySetupForm, useCompanySetupForm } from '../../CompanySetupForm';
import {
  CompanySetupTabType,
  CompanySetupTabWrapper,
} from '../CompanySetupTabWrapper';

const isFinalizationMode = true;

type Props = {
  employerId: string;
  isDon: boolean;
};

export const CompanySetupTab = ({ employerId, isDon }: Props) => {
  const { companySetupForm, onSubmit } = useCompanySetupForm(
    employerId,
    isFinalizationMode
  );
  const { formState } = companySetupForm;

  return (
    <CompanySetupTabWrapper
      onCancel={() => companySetupForm.reset()}
      tab={CompanySetupTabType.COMPANY_SETUP}
      employerId={employerId}
      formState={formState}
      onSubmit={onSubmit}
      isDon={isDon}
    >
      <CompanySetupForm
        isFinalizationMode={isFinalizationMode}
        companySetupForm={companySetupForm}
      />
    </CompanySetupTabWrapper>
  );
};
